import { ActionControllerEventName, ResourcesManager, Viewer, ViewerModule } from '@verybigthings/vbt-webvr-framework';
import { Vector3 } from 'three';
import { PickingControllerEvents } from "@verybigthings/vbt-webvr-framework/build/main/ts/controls/PickingController";
import { PreparationPickingObjects } from "../../utils/PreparationPickingObjects";
export default class SerologicalTestTubeHolderModule extends ViewerModule {
    constructor(level) {
        super();
        this.__inited = false;
        this.pointerController = Viewer.pointerController;
        this.model = ResourcesManager.getModel('micropipette_holder_3').clone();
        this.addObject(this.model);
        this.level = level;
    }
    init() {
        this.testTube1 = ResourcesManager.getModel('test_tube_empty').clone();
        this.testTube1.position.set(-.50, .16, 0);
        this.addObject(this.testTube1);
        this.testTube2 = ResourcesManager.getModel('test_tube_empty').clone();
        this.testTube2.position.set(0, .16, 0);
        this.addObject(this.testTube2);
        this.testTube3 = ResourcesManager.getModel('test_tube_empty').clone();
        this.testTube3.position.set(.51, .16, 0);
        this.addObject(this.testTube3);
    }
    createClickEvent() {
        let callback;
        this.actionController.on(ActionControllerEventName.click, this.uiObject, callback = () => {
            if (Viewer.controls.zController)
                return;
            if (!this.level.interaction)
                return;
            this.fire('holder_clicked');
            this.actionController.off(ActionControllerEventName.click, this.uiObject, callback);
        });
        if (this.level.lobby.app.zSpacePickingController) {
            const pipetteUiObject = this.level.instruments.pipette.uiObject;
            PreparationPickingObjects.saveObjectState(pipetteUiObject);
            this.level.lobby.app.zSpacePickingController.on(PickingControllerEvents.RELEASED, pipetteUiObject, () => {
                const distanceToTubes = this.level.instruments.pipette.model.getWorldPosition(new Vector3()).distanceTo(new Vector3(2.1, -16.9, -19.5));
                if (distanceToTubes < 1.6) {
                    this.fire('holder_clicked');
                    this.level.lobby.app.zSpacePickingController.off(PickingControllerEvents.PICKED, pipetteUiObject);
                    this.level.lobby.app.zSpacePickingController.off(PickingControllerEvents.RELEASED, pipetteUiObject);
                }
                else {
                    PreparationPickingObjects.flyObjectToPrevState(pipetteUiObject, 0);
                }
                setTimeout(() => pipetteUiObject.traverse(el => {
                    if (el.userData.oldRaycast)
                        el.raycast = el.userData.oldRaycast;
                }));
                this.actionController.off(ActionControllerEventName.click, this.uiObject, callback);
            });
        }
    }
    setLeftTube(volume) {
        this.disposeObject(this.testTube1);
        this.emptyTestTube = ResourcesManager.getModel(volume === 5 ? 'serological_test_tube_red_5' : volume < 5 ? 'serological_test_tube_red_3' : 'serological_test_tube_red_8').clone();
        this.emptyTestTube.position.set(-.50, .16, 0);
        this.addObject(this.emptyTestTube);
    }
    setCenterTube(volume) {
        this.disposeObject(this.testTube2);
        this.testTube1 = ResourcesManager.getModel(volume === 5 ? 'serological_test_tube_red_5' : volume < 5 ? 'serological_test_tube_red_3' : 'serological_test_tube_red_8').clone();
        this.testTube1.position.set(0, .16, 0);
        this.addObject(this.testTube1);
    }
    setRightTube(volume) {
        this.disposeObject(this.testTube3);
        this.testTube2 = ResourcesManager.getModel(volume === 5 ? 'serological_test_tube_red_5' : volume < 5 ? 'serological_test_tube_red_3' : 'serological_test_tube_red_8').clone();
        this.testTube2.position.set(.51, .16, 0);
        this.addObject(this.testTube2);
    }
}
